import React 			from 'react';
import FeedbackStore 	from '../stores/FeedbackStore';	
import FeedbackActions 	from '../actions/FeedbackActions';
import FeedbackItem 	from './FeedbackItem.react';

function getAppState() {

	return {

		feedback 	: 	FeedbackStore.getMyFeedback()
	}
}

class Feedback extends React.Component {

	constructor( props ) {

		super( props );
		
		this._onChange = this._onChange.bind( this )


		this.state 	= getAppState();
	}

	componentWillReceiveProps( newProps ) {

		this.setState( getAppState() );
	}

	componentDidMount() {
		
		FeedbackStore.addChangeListener( this._onChange );
		FeedbackActions.loadFeedback();
	}

	render() {

		let feedback = this.state.feedback.map( function( feedbackItem, i ) {

			return (

				<FeedbackItem myKey={i} key={i} feedback={feedbackItem} />
			)
		})

		if( this.state.feedback.length === 0 ) {

			feedback = (

				<p>You have no pending feedback</p>
			);
		}

		return ( 

			<div>
				<div className="row">

					<div className="col-md-12">

						<h2>Feedback</h2>

						<div className="clr"></div>

						<br /><br />

						{feedback}
					</div>
				</div>
			</div>
		)
	}

	_onChange() {

		this.setState( getAppState() );
	}
}

export default Feedback;


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/Feedback.react.js